<template>
  <button v-if="!to" v-on="$listeners" class="bg-brand-green p-3 text-white rounded-lg"><slot /></button>
  <router-link v-else :to="to"><button class="bg-brand-green p-3 text-white rounded-lg"><slot /></button></router-link>
</template>

<script>

export default {
  name: 'Button',
  props: {
    to: {
      type: String,
      required: false
    }
  }
}
</script>
